import React, { useState } from "react";

export default function DistributiveMultiplication() {
  const [num1, setNum1] = useState(23);
  const [num2, setNum2] = useState(47);
  const [inputs, setInputs] = useState({ p1: "", p2: "", p3: "", p4: "", sum: "" });
  const [hints, setHints] = useState({ p1: "", p2: "", p3: "", p4: "" });
  const [finalResult, setFinalResult] = useState("");
  const [celebrate, setCelebrate] = useState(false);

  function splitNumber(n) {
    const tens = Math.floor(n / 10) * 10;
    const ones = n % 10;
    return { n, tens, ones };
  }

  const expectedValues = () => {
    const a = splitNumber(num1);
    const b = splitNumber(num2);
    const p1 = a.tens * b.tens;
    const p2 = a.tens * b.ones;
    const p3 = a.ones * b.tens;
    const p4 = a.ones * b.ones;
    const total = p1 + p2 + p3 + p4;
    return { p1, p2, p3, p4, total, a, b };
  };

  const handleCheckOne = (id) => {
    const ex = expectedValues();
    const val = Number(inputs[id]);
    if (val === ex[id]) {
      setHints((prev) => ({ ...prev, [id]: "Great! That is correct." }));
    } else {
      setHints((prev) => ({ ...prev, [id]: 'Try again ' }));
    }
  };

  const handleCheckAll = () => {
    const ex = expectedValues();
    ["p1", "p2", "p3", "p4"].forEach((id) => handleCheckOne(id));
    if (Number(inputs.sum) === ex.total) {
      setFinalResult(`${ex.total} — Correct!`);
      setCelebrate(true);
      setTimeout(() => setCelebrate(false), 2200);
    } else {
      setFinalResult("Not yet — check the partials.");
    }
  };

  const handleShowSolution = () => {
    const ex = expectedValues();
    setInputs({ p1: ex.p1, p2: ex.p2, p3: ex.p3, p4: ex.p4, sum: ex.total });
    setFinalResult(`${ex.total} — Solution shown`);
    setCelebrate(true);
    setTimeout(() => setCelebrate(false), 2200);
  };

  const ex = expectedValues();

  return (
    <div style={{ fontFamily: "Inter, sans-serif", padding: 18, background: "#000000", minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div style={{ maxWidth: 600, width: "100%", background: "white", borderRadius: 18, padding: 22, boxShadow: "0 8px 30px rgba(250, 249, 249, 0.08)" }}>
        
        <header style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
          <div style={{ width: 264, height: 64, borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", color: "black", fontWeight: 900, fontSize: 30 }}>2 Digit X 2 Digit</div>
        </header>

        <div style={{ display: "flex", justifyContent: "center", gap: 12, flexWrap: "wrap", marginBottom: 10 }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <label style={{ fontSize: 13, color: "#6b6b6b" }}>Number 1</label>
            <input type="number" value={num1} onChange={(e) => setNum1(Number(e.target.value))} style={{ width: 90, padding: "10px 12px", borderRadius: 10, border: "2px dashed #ffe6ef", fontSize: 18 }} />
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <label style={{ fontSize: 13, color: "#6b6b6b" }}>Number 2</label>
            <input type="number" value={num2} onChange={(e) => setNum2(Number(e.target.value))} style={{ width: 90, padding: "10px 12px", borderRadius: 10, border: "2px dashed #ffe6ef", fontSize: 18 }} />
          </div>

          <button onClick={() => setInputs({ p1: "", p2: "", p3: "", p4: "", sum: "" })} style={{ padding: "10px 14px", borderRadius: 12, border: 0, background: "#ff7aa2", color: "white", fontWeight: 600 }}>Load Example</button>

          <button 
            onClick={() => {
                setNum1(Math.floor(Math.random() * 50) + 50); // random 10–99
setNum2(Math.floor(Math.random() * 50) + 50); // random 10–99

            //   setNum1(Math.floor(Math.random() * 41) + 10); // random between 10 and 50
            //   setNum2(Math.floor(Math.random() * 41) + 10); // random between 10 and 50
              setInputs({ p1: "", p2: "", p3: "", p4: "", sum: "" });
            }} 
            style={{ padding: "10px 14px", borderRadius: 12, border: 0, background: "#6FD7D9", color: "#3b2d06", fontWeight: 600 }}
          >
            Random Example
          </button>
        </div>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 18, marginTop: 12 }}>
          <div style={{ width: "100%", background: "white", padding: 14, borderRadius: 12, border: "1px solid #fff6f6" }}>
            <div style={{ display: "flex", justifyContent: "center", gap: 10, marginBottom: 8 }}>
              <div>
                <div style={{ padding: "8px 10px", borderRadius: 8, background: "#fff5f8", border: "2px solid #ffe6ef", fontWeight: 700 }}>Number 1: {ex.a.n}</div>
                <div style={{ fontSize: 14, padding: "8px 10px", borderRadius: 8 }}>Tens: <strong>{ex.a.tens}</strong> Ones: <strong>{ex.a.ones}</strong></div>
              </div>
              <div style={{ fontWeight: 800 }}>×</div>
              <div>
                <div style={{ padding: "8px 10px", borderRadius: 8, background: "#fff5f8", border: "2px solid #ffe6ef", fontWeight: 700 }}>Number 2: {ex.b.n}</div>
                <div style={{ fontSize: 14, padding: "8px 10px", borderRadius: 8 }}>Tens: <strong>{ex.b.tens}</strong> Ones: <strong>{ex.b.ones}</strong></div>
              </div>
            </div>

            {["p1", "p2", "p3", "p4"].map((id, i) => (
              <div key={id} style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 8, padding: 10, border: "1px dashed #ffecec", borderRadius: 10, justifyContent: "center" }}>
                <label style={{ minWidth: 150 }}>{i + 1}) {id === "p1" && `${ex.a.tens} × ${ex.b.tens}`}{id === "p2" && `${ex.a.tens} × ${ex.b.ones}`}{id === "p3" && `${ex.a.ones} × ${ex.b.tens}`}{id === "p4" && `${ex.a.ones} × ${ex.b.ones}`}</label>
                <input type="text" value={inputs[id]} onChange={(e) => setInputs({ ...inputs, [id]: e.target.value })} style={{ width: 120, padding: "8px 10px", borderRadius: 8, border: "2px solid #fff6f6" }} />
                <button onClick={() => handleCheckOne(id)} style={{ padding: "8px 10px", borderRadius: 8, border: 0, background: "#e6f9f0", color: "#0a7a4b", fontWeight: 700 }}>Check</button>
                <div style={{ fontSize: 13, color: "#6b6b6b" }}>{hints[id]}</div>
              </div>
            ))}

            <div style={{ marginTop: 10, display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
              <input type="text" placeholder="Enter total" value={inputs.sum} onChange={(e) => setInputs({ ...inputs, sum: e.target.value })} style={{ width: 160, padding: 10, borderRadius: 10, border: "2px dashed #fff6f6", fontSize: 18 }} />
              <div style={{ display: "flex", gap: 10 }}>
                <button onClick={handleCheckAll} style={{ padding: "8px 10px", borderRadius: 8, background: "#e6f9f0", color: "#0a7a4b", fontWeight: 700 }}>Check All</button>
                <button onClick={() => setInputs({ p1: "", p2: "", p3: "", p4: "", sum: "" })} style={{ padding: "10px 14px", borderRadius: 12, background: "#ffd166", color: "#3b2d06", fontWeight: 600 }}>Reset</button>
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 14, display: "flex", justifyContent: "center", fontWeight: 800, fontSize: 18, color: "#ff7aa2" }}>
          {finalResult}
        </div>

        {celebrate && (
          <div style={{ position: "fixed", right: 18, bottom: 18, padding: "12px 16px", borderRadius: 12, background: "#e6fff8", border: "1px solid #c6f2e8", color: "#0d6b4a", boxShadow: "0 8px 30px rgba(10,80,60,0.06)" }}>🎉 Nice! All correct!</div>
        )}
      </div>
    </div>
  );
}
